<template>
  <div class="case-item px-2 py-4" :style="styles">
    <div v-if="!isDud" class="inner text-center">
      <v-img
        :src="`https://community.cloudflare.steamstatic.com/economy/image/${item.image}/164x164`"
        aspect-ratio="1" :width="imageSize" contain
        class="mx-auto mb-4"
      />

      <div
        :style="{color: item.color}"
        class="item-name font-weight-semibold text-truncate text-body-2 text-center mb-1"
        v-text="item.id"
      />
      <div v-if="item.price" class="text-body-2">
        <scrap v-if="isScrap" :amount="item.price" />
        <span v-else>${{ item.price | toScrap }}</span>
      </div>
    </div>
    <div v-else class="inner text-center">
      <v-img
        :src="require('@/assets/img/games/cases/dud.png')"
        aspect-ratio="1" width="56" contain
        class="mx-auto mb-3 faded-8"
      />

      <h4 class="text-body-1 mb-1 font-weight-bold">
        Dud!
      </h4>
      <p class="text-caption text--disabled lh-1-2 mb-0">
        Well thats embarrassing...
      </p>
    </div>


    <div v-if="item.odds" class="item-odds lh-1 text-caption text--secondary">
      <div class="odds-info">
        {{ item.odds * 100 | toLocale(4) }}%
      </div>

      <div class="ticket-range">
        {{ item.ticketRange.join(' - ') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    imageSize: {
      type: Number,
      default: 56,
    },
    isScrap: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    styles() {
      const { item } = this
      return {
        '--color': item.color,
      }
    },
    isDud() {
      return this.item.id === 'dud'
    },
  },
}
</script>

<style lang="scss">
.case-item {
  overflow: hidden;
  position: relative;

  .inner {
    position: relative;
    z-index: 2;
  }

  .item-odds {
    position: absolute;
    z-index: 4;
    top: 0;
    right: 0;
    width: 100%;
    pointer-events: none;

    .odds-info,
    .ticket-range {
      position: absolute;
      top: 0;
      right: 0;
      padding: 10px;
      transition: transform 0.3s ease, opacity 0.3s ease;
    }

    .ticket-range {
      opacity: 0;
      transform: translateY(70%);
    }
  }

  &:hover {
    .odds-info {
      opacity: 0;
      transform: translateY(-70%);
    }

    .ticket-range {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &::before {
    @include overlay;

    opacity: 0.3;
    background: radial-gradient(circle at top, var(--color) 25%, transparent 80%);
    content: ' ';
    pointer-events: none;
  }
}
</style>
